import React, { useState } from "react";
import { InboxOutlined, LoadingOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";

const { Dragger } = Upload;

export const allowedDocExtensions = [
  "pdf",
  "doc",
  "docx",
  "dot",
  "dotx",
  "docm",
];

export const allowedDocMimeTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  "application/vnd.ms-word.document.macroEnabled.12",
  "application/vnd.ms-word.template.macroEnabled.12",
];

export const allowedExcelExtensions = [
  "xls",
  "xlsx",
  "xlsm",
  "xlsb",
  "xltx",
  "xltm",
];

export const allowedExcelMimeTypes = [
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel.sheet.macroEnabled.12", // .xlsm
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12", // .xlsb
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template", // .xltx
  "application/vnd.ms-excel.template.macroEnabled.12", // .xltm
];

export default function FileUploadDragger({
  onChange,
  onRemove,
  type,
  disabled,
}) {
  const [uploading, setUploading] = useState(false);
  const hideListAndShowLoader =
  type === "totAgreement" || type === "priceAndMargin";

  const beforeUpload = (file) => {
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (type === "receiverPic" || type === "podDocument") {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
        return Upload.LIST_IGNORE;
      }
    }
    if (type === "totAgreement") {
      const isAllowedExtension = allowedDocExtensions.includes(fileExtension);
      const isAllowedMime = allowedDocMimeTypes.includes(file.type);

      if (!isAllowedExtension && !isAllowedMime) {
        message.error(
          "Only PDF or Microsoft Word files (.pdf, .doc, .docx, .dot, .dotx, .docm) are allowed!"
        );
        return Upload.LIST_IGNORE;
      }
    }

    if (type === "priceAndMargin") {
      const isAllowedExtension = allowedExcelExtensions.includes(fileExtension);
      const isAllowedMime = allowedExcelMimeTypes.includes(file.type);

      if (!isAllowedExtension && !isAllowedMime) {
        message.error(
          "Only Excel files are allowed (.xls, .xlsx, .xlsm, .xlsb, .xltx, .xltm)"
        );
        return Upload.LIST_IGNORE;
      }
    }

    const isLt5MB = file.size / 1024 / 1024 < 5;
    if (!isLt5MB) {
      message.error("Image must be smaller than 5MB!");
      return Upload.LIST_IGNORE;
    }

    return true; // allow upload
  };

  const customRequest = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      if (hideListAndShowLoader) setUploading(true);
      await onChange(file, (percent) => {
        onProgress({ percent });
      });

      onSuccess("Upload complete");
      message.success(`File uploaded successfully.`);
    } catch (err) {
      console.error(err);
      onError(err);
      message.error("Upload failed");
    }finally {
      if (hideListAndShowLoader) setUploading(false); 
    }
  };

  return (
    <Dragger
      name="file"
      multiple={false}
      beforeUpload={beforeUpload}
      customRequest={customRequest}
      showUploadList={!hideListAndShowLoader}
      onRemove={onRemove}
      disabled={disabled}
      style={{
        minHeight: 44, // similar to AntD button height
        padding: "6px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <InboxOutlined style={{ fontSize: 18 }} />
        <span style={{ fontSize: 14 }}>Click or drag file to upload</span>
      </div> */}
      {hideListAndShowLoader && uploading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: "#1677ff",
          }}
        >
          <LoadingOutlined style={{ fontSize: 18 }} />
          <span>Uploading...</span>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <InboxOutlined style={{ fontSize: 18 }} />
          <span style={{ fontSize: 14 }}>
            Click or drag file to upload
          </span>
        </div>
      )}
    </Dragger>
  );
}
